export default __webpack_public_path__ + "static/media/covid.99ea153d.jpg";